import { JSX, useRef, useState } from "react"
import KanbanBoard from "../../../components/Kanban/Kanban";
import { useAuth } from "../../../contexts/AuthProvider/useAuth";
import { ButtonCard, formatDateTime, formatMonetary } from "../../../commons/utils";
import { FiltroMovimentoKanban } from "./Filtro";
import { Download, Paperclip, Printer } from "lucide-react";
import { getTipoMovStatus } from "./utils";
import { Gallery, GalleryHandler } from "../../Gallery";
import { deleteMovimentoArquivo, getFilesMovimento, uploadMovimentoArquivo } from "../Movimentos/utils";
import PdfGenerator, { PdfGeneratorHandler } from "../../../components/PdfGenerator";

function createButton(hint: string, color: string, icon: JSX.Element, onClick: () => void) {
    return (
        <ButtonCard hint={hint} color={color} iconcenter={icon} onClick={onClick} className='p-1 me-1' />
    );
}

export const MovimentosKanban = () => {
    const auth = useAuth();

    const refKanbam = useRef<any>(null);
    const refFiltro = useRef<any>(null);
    const refgallery = useRef<GalleryHandler>(null);
    const refMovimentoPdf = useRef<PdfGeneratorHandler>(null);

    const [status, setStatus] = useState<any>([]);

    function onGetData(data: any, tipmovcontador: number) {
        const newArray: any = [];
        refKanbam.current?.setTasks([]);

        getTipoMovStatus(auth, tipmovcontador).then(pStatus => {
            setStatus(pStatus)

            data.forEach((item: any) => {
                const { movid, tipmovcontador, tipmovstid, movnumero, clinome, usunome, movnumeronf, movnumeropedido, movemissao,
                    movobservacao/*, produtos */, valortotal, movdesconto } = item;

                const id = movid;
                const content =
                    <div style={{ paddingTop: '5px' }}>
                        {clinome && <div style={{ paddingBottom: '5px' }}>{clinome}</div>}
                        <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
                            {movnumeronf && <div style={{ fontSize: '12px', paddingBottom: '7px' }}>NF: {movnumeronf}</div>}
                            {movnumeropedido && <div style={{ fontSize: '12px', paddingBottom: '7px' }}>Venda: {movnumeropedido}</div>}
                        </div>
                        {usunome && <div style={{ fontSize: '12px', paddingBottom: '7px' }}>{usunome}</div>}
                        {movobservacao && <div style={{ fontSize: '12px', paddingBottom: '7px' }}>{movobservacao}</div>}
                        <div style={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap' }}>
                            {movemissao && <div style={{ fontSize: '12px', paddingBottom: '7px' }}>{formatDateTime(movemissao)}</div>}
                            {((valortotal > 0) || (movdesconto > 0)) &&
                                <div style={{ display: 'flex', justifyContent: 'flex-end', flex: 1 }}>
                                    <div style={{ fontSize: '14px' }}>
                                        {movdesconto ?
                                            <div style={{ fontSize: '12px', whiteSpace: 'nowrap' }}><span>{formatMonetary(valortotal) + ' - ' + formatMonetary(movdesconto) + ' = '}</span>
                                                <span style={{ fontSize: '14px', textAlign: 'right' }}>{formatMonetary(valortotal - movdesconto).toString()}</span>
                                            </div> :
                                            formatMonetary(valortotal)}
                                    </div>
                                </div>
                            }
                        </div>
                    </div>

                const columnId = tipmovstid;

                const details =
                    <div>
                        <div style={{ fontSize: '14px', fontWeight: '600' }}>Nº {movnumero}</div>
                    </div>

                const color = pStatus.find((_status: any) => _status.value === tipmovstid)?.color;

                const functions = (
                    <>
                        {createButton('Arquivos', color, <Paperclip size={20} />,
                            async () => {
                                const files = await getFilesMovimento(auth, tipmovcontador, movid);
                                refgallery.current?.openModal(files, '', movid, false);
                            }
                        )}
                        {/* {createMenu('Imprimir', color, <Printer size={20} />, (mode) => refMovimentoPdf.current?.generatePDF(mode, tipmovcontador, movid))} */}
                        {createButton('Baixar', color, <Download size={20} />, () => refMovimentoPdf.current?.generatePDF('download', { tipmovcontador, movid }))}
                        {createButton('Imprimir', color, <Printer size={20} />, () => refMovimentoPdf.current?.generatePDF('view', { tipmovcontador, movid }))}
                    </>
                );

                const filterValues: string[] = [movnumero, clinome, usunome, movnumeronf, movnumeropedido];

                newArray.push({ id, content, columnId, details, undefined, functions, filterValues });
            });

            refKanbam.current?.setTasks(newArray);
        })
    }

    return (
        status &&
        <>
            <KanbanBoard
                ref={refKanbam}
                columnsId={status?.map((item: any) => item.id)}
                status={status}
                filter={() => {
                    return <FiltroMovimentoKanban ref={refFiltro} onGetData={onGetData} />
                }}
            />
            <PdfGenerator ref={refMovimentoPdf} api="/v1/movimentopdfgenerate" />
            <Gallery ref={refgallery} onUploadFile={(movid, file) => uploadMovimentoArquivo(auth, movid, file)} onRemoveFile={(movid, file) => deleteMovimentoArquivo(auth, movid, file)} />
        </>
    )
}